import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { LoadingSpinner } from '../components';
import { UserRole } from '../types';
import { staffHomeRoute } from '../services/staff/staffRole.workflow';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;
  allowedRoles?: UserRole[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole, allowedRoles }) => {
  const user = useAuthStore(state => state.user);
  const loading = useAuthStore(state => state.loading);
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if ((requiredRole && user.role !== requiredRole) || (allowedRoles && !allowedRoles.includes(user.role))) {
    // Redirect to appropriate dashboard based on user's role
    return <Navigate to={staffHomeRoute(user.role)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
